<template>
    <form class="f fv c-el-panel-bg ath-global-modal-el-blank">
        <header class="f fh fa-c fj-l el-modal-header">
            <h2 class="el-modal-title">
                <slot name="title"></slot>
            </h2>
            <span class="fg"></span>
            <ButtonIcon v-if="uiClose" icon="cross" @click="close" />
        </header>
        <slot name="nav"></slot>
        <main class="f fv el-modal-body">
            <slot name="body"></slot>
        </main>
        <footer class="el-modal-footer" v-if="uiFooter">
            <slot name="footer"></slot>
        </footer>
    </form>
</template>

<script>
import ButtonIcon from '../../atoms/ButtonIcon.vue';

export default {
    name: 'mead-blank-modal',
    components: {ButtonIcon},
    props: {
        /**
         * Width of the modal, in rem units, applied directly to the root element's style.
         */
        uiWidth     : {type: [Number, String], default: () => 45},
        /**
         * Height of the modal, in rem units, applied directly to the root element's
         * style. False leaves the height to size naturally with its content.
         */
        uiHeight    : {type: [Boolean, Number, String], default: () => false},
        /**
         * Whether to render the footer section (and its footer slot).
         */
        uiFooter    : {type: Boolean, default: () => true},
        /**
         * Whether to show the close (X) button in the header.
         */
        uiClose     : {type: Boolean, default: () => true},
    },
    watch: {
        uiWidth: function () {
            this.setWidth();
        },
        uiHeight: function () {
            this.setHeight();
        },
    },
    methods: {
        setWidth: function () {
            if (!this.$el || !this.uiWidth) return;
            this.$el.style.width = `${this.uiWidth}rem`;
        },
        setHeight: function () {
            if (!this.$el || !this.uiHeight) return;
            this.$el.style.height = `${this.uiHeight}rem`;
        },
        close: function () {
            MeadCommon.ModalService.close();
        },
    },
    mounted () {
        this.setWidth();
        this.setHeight();
    },
};
</script>
